import React from 'react';
import { Container, Typography, Grid, TextField, FormControl, InputLabel, Select, MenuItem, Checkbox, FormControlLabel, Button, Paper, Table, TableHead, TableRow, TableCell, TableBody, Box, Tooltip, IconButton } from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

const motivationOptions = [
  { label: 'Growth', value: 'growth' },
  { label: 'Succession', value: 'succession' },
  { label: 'Evaluating', value: 'no_motivation' },
];
const activityOptions = [
  { label: 'Valuation', value: 'valuation' },
  { label: 'Profile', value: 'profile' },
  { label: 'Discovery', value: 'discovery' },
  { label: 'Education', value: 'education' },
  { label: 'Consultation', value: 'consultation' },
  { label: 'Deal Room', value: 'deal_room' },
];
const goalTypeOptions = [
  { label: 'Completion Rate', value: 'completion_rate' },
  { label: 'Median TTFU', value: 'median_ttfu' },
];
const windowOptions = [7, 14, 30, 60, 90];

class GoalsAdmin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      goals: [],
      form: { motivation: '', activity: '', goal_type: '', window_days: 30, threshold_value: 0.5, enabled: true },
    };
  }

  componentDidMount() {
    this.fetchGoals();
  }

  fetchGoals = async () => {
    const res = await fetch('/api/motivation_adoption_goals', { method: 'GET', headers: { 'Accept': 'application/json' }, credentials: 'same-origin' });
    if (!res.ok) return;
    const data = await res.json();
    const list = Array.isArray(data) ? data : (Array.isArray(data.goals) ? data.goals : []);
    this.setState({ goals: list });
  };

  createGoal = async () => {
    const payload = { motivation_adoption_goal: { ...this.state.form, window_days: parseInt(this.state.form.window_days, 10) } };
    const res = await fetch('/api/motivation_adoption_goals', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload), credentials: 'same-origin' });
    if (res.ok) {
      this.setState({ form: { ...this.state.form, motivation: '', activity: '', goal_type: '' } });
      this.fetchGoals();
    }
  };

  updateGoal = async (id, patch) => {
    const payload = { motivation_adoption_goal: patch };
    const res = await fetch(`/api/motivation_adoption_goals/${id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload), credentials: 'same-origin' });
    if (res.ok) this.fetchGoals();
  };

  deleteGoal = async (id) => {
    const res = await fetch(`/api/motivation_adoption_goals/${id}`, { method: 'DELETE', credentials: 'same-origin' });
    if (res.ok) this.fetchGoals();
  };

  render() {
    const { goals, form } = this.state;

    return (
      <Container maxWidth="lg" style={{ paddingTop: 24, paddingBottom: 48 }}>
        <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
          <Typography variant="h5">Motivation Adoption Goals</Typography>
          <Button href="/admin/motivation_adoption" variant="contained" color="primary">Adoption Dashboard</Button>
        </Box>
        <Paper style={{ padding: 16, marginBottom: 24 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={2}>
              <FormControl fullWidth>
                <InputLabel>Motivation</InputLabel>
                <Select value={form.motivation} onChange={(e) => this.setState({ form: { ...form, motivation: e.target.value } })}>
                  {motivationOptions.map(o => <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>)}
                </Select>
              </FormControl>
              <Tooltip title="Choose which user motivation this goal applies to (Growth, Succession, Evaluating)." placement="top" arrow><IconButton size="small" style={{ backgroundColor: '#e0e0e0' }}><InfoOutlinedIcon fontSize="small" /></IconButton></Tooltip>
            </Grid>
            <Grid item xs={12} md={2}>
              <FormControl fullWidth>
                <InputLabel>Activity</InputLabel>
                <Select value={form.activity} onChange={(e) => this.setState({ form: { ...form, activity: e.target.value } })}>
                  {activityOptions.map(o => <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>)}
                </Select>
              </FormControl>
              <Tooltip title="Pick the Getting Started activity to target (e.g., Discovery, Valuation, Deal Room)." placement="top" arrow><IconButton size="small" style={{ backgroundColor: '#e0e0e0' }}><InfoOutlinedIcon fontSize="small" /></IconButton></Tooltip>
            </Grid>
            <Grid item xs={12} md={2}>
              <FormControl fullWidth>
                <InputLabel>Goal Type</InputLabel>
                <Select value={form.goal_type} onChange={(e) => this.setState({ form: { ...form, goal_type: e.target.value } })}>
                  {goalTypeOptions.map(o => <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>)}
                </Select>
              </FormControl>
              <Tooltip title="Completion Rate compares Adoption % to threshold; Median TTFU compares median days to threshold." placement="top" arrow><IconButton size="small" style={{ backgroundColor: '#e0e0e0' }}><InfoOutlinedIcon fontSize="small" /></IconButton></Tooltip>
            </Grid>
            <Grid item xs={12} md={2}>
              <FormControl fullWidth>
                <InputLabel>Window (days)</InputLabel>
                <Select value={form.window_days} onChange={(e) => this.setState({ form: { ...form, window_days: parseInt(e.target.value, 10) } })}>
                  {windowOptions.map(w => <MenuItem key={w} value={w}>{w}</MenuItem>)}
                </Select>
              </FormControl>
              <Tooltip title="Number of days from onboarding to measure against (7, 14, 30, 60, 90)." placement="top" arrow><IconButton size="small" style={{ backgroundColor: '#e0e0e0' }}><InfoOutlinedIcon fontSize="small" /></IconButton></Tooltip>
            </Grid>
            <Grid item xs={12} md={2}>
              <TextField label="Threshold" type="number" value={form.threshold_value} onChange={(e) => this.setState({ form: { ...form, threshold_value: parseFloat(e.target.value) } })} fullWidth />
              <Tooltip title="Target value: e.g., 0.6 for 60% completion rate; or 7 for median TTFU <= 7 days." placement="top" arrow><IconButton size="small" style={{ backgroundColor: '#e0e0e0' }}><InfoOutlinedIcon fontSize="small" /></IconButton></Tooltip>
            </Grid>
            <Grid item xs={12} md={2}>
              <FormControlLabel control={<Checkbox checked={form.enabled} onChange={(e) => this.setState({ form: { ...form, enabled: e.target.checked } })} />} label="Enabled" />
            </Grid>
          </Grid>
          <Box mt={2}><Button variant="contained" color="primary" onClick={this.createGoal}>Create Goal</Button></Box>
        </Paper>

        <Paper>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Motivation</TableCell>
                <TableCell>Activity</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Window</TableCell>
                <TableCell>Threshold</TableCell>
                <TableCell>Enabled</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(Array.isArray(goals) ? goals : []).map(g => (
                <TableRow key={g.id} hover>
                  <TableCell>{motivationOptions.find(o => o.value === g.motivation)?.label || g.motivation}</TableCell>
                  <TableCell>{activityOptions.find(o => o.value === g.activity)?.label || g.activity}</TableCell>
                  <TableCell>{goalTypeOptions.find(o => o.value === g.goal_type)?.label || g.goal_type}</TableCell>
                  <TableCell>{g.window_days}d</TableCell>
                  <TableCell>{g.threshold_value}</TableCell>
                  <TableCell>{g.enabled ? 'Yes' : 'No'}</TableCell>
                  <TableCell>
                    <Button size="small" onClick={() => this.updateGoal(g.id, { enabled: !g.enabled })}>{g.enabled ? 'Disable' : 'Enable'}</Button>
                    <Button size="small" color="secondary" onClick={() => this.deleteGoal(g.id)}>Delete</Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      </Container>
    );
  }
}

export default GoalsAdmin; 